import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import { Box, Stack, Tooltip } from '@mui/material';
import { ColDef } from '@siloreal:modules:private/silobag-list/config/extra/types';
import UTILS from '@siloreal:modules:private/silobag-list/config/extra/utils';
import { VrrBadge } from '@siloreal:modules:private/silobag-list/config/ui/vrr-badge';
import * as HOOKS from '@siloreal:shared:hooks';

const VRR_INIT_BG = '#EEF0F2';
const VRR_INIT_BORDER = '#C5C9CF';
const VRR_INIT_ICON = '#6F757C';

export function buildVrrColumn(): ColDef {
  return {
    field: 'vrr',
    headerName: HOOKS.useLocale.getState().t('temp.private.list.silospro.vrr'),
    headerAlign: 'center',
    minWidth: 84,
    sortable: false,
    renderCell: (params) => {
      const tagForVRR = UTILS.extract.tag.system(params.row, (tag) => tag.label.startsWith('VRR_'));
      if (!tagForVRR) return <VrrInitializing />;

      const isOkVRR = UTILS.is.vrr.ok(tagForVRR);

      return (
        <Stack height="100%" direction="row" justifyContent="center" alignItems="center">
          <VrrBadge ok={isOkVRR} />
        </Stack>
      );
    },
  };
}

function VrrInitializing() {
  const i18n = HOOKS.useLocale();
  const VRR_INIT_TOOLTIP = i18n.t('temp.common.no_recent_data') + '.';
  return (
    <Stack height="100%" direction="row" justifyContent="center" alignItems="center">
      <Tooltip title={VRR_INIT_TOOLTIP} placement="top" arrow>
        <Box
          aria-label={VRR_INIT_TOOLTIP}
          sx={{
            width: 28,
            height: 28,
            borderRadius: 2,
            backgroundColor: VRR_INIT_BG,
            border: `1px dashed ${VRR_INIT_BORDER}`,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'default',
          }}
        >
          <HourglassEmptyIcon aria-hidden sx={{ color: VRR_INIT_ICON, fontSize: 16 }} />
        </Box>
      </Tooltip>
    </Stack>
  );
}
